import { IReduxAction } from '~/services/interfaces/common-interface';
import {
  SET_LOADING_DATA,
  GET_ALL_SUCCESS,
  GET_RECOMMENDATION_SUCCESS,
  SET_LOADING_RECOMMENDATION
} from './sales-tracking-constants';

export const INITIAL_STATE: any = {
  loadingData: true,
  loadingRecommendation: true,
  indicators: {},
  recommendation: {}
};

const salesTrackingReducer = (state = { ...INITIAL_STATE }, action: IReduxAction) => {
  switch (action.type) {
    case SET_LOADING_DATA: {
      return {
        ...state,
        loadingData: action.loading
      };
    }

    case SET_LOADING_RECOMMENDATION: {
      return {
        ...state,
        loadingRecommendation: action.loading
      };
    }

    case GET_ALL_SUCCESS: {
      return {
        ...state,
        indicators: action.payload
      };
    }

    case GET_RECOMMENDATION_SUCCESS: {
      return {
        ...state,
        recommendation: action.payload
      };
    }

    default:
      return state;
  }
};

export default salesTrackingReducer;
